import defaultCode from "./defaultCode";
import lesson from "./lesson";
import test from "./test";

export default {
    name: "Introduction",
    defaultCode,
    lesson,
    test,
    difficulty: 0,
};
